
 import { useEffect, useState } from "react";
 import MDBox from "components/MDBox";
 import { useMaterialUIController } from "context";
 import CTLTable from "application/components/CTLTable";
 import { getColumns, Attributes, operationURLS } from "./model";
 import DeleteConfirmation from "application/components/DeleteConfirmation";
 import CTLAdvancedFilter from "application/components/CTLAdvancedFilter";
 import { application } from "globals/endpoints";
 import CTLBaseDialogForm from "application/components/CTLBaseDialogForm";
 import CTLNotification from "application/components/CTLNotification";
import { getCallCenterConfigurationsMenu } from "globals/configuration/callCenterConfigurationMenu";
 
 function PredefinedMessage({
   onLoad,
   pageId,
   searchText,
   registerCallBacks,
   pageName,
 }) {
   const [controller, dispatch] = useMaterialUIController();
   const { activePage } = controller;
   const [confirmDelete, setConfirmDelete] = useState(false);
   const [selectedRow, setSelectedRow] = useState([]);
   const [openFilter, setOpenFilter] = useState(false);
   const [advancedFilters, setAdvancedFilters] = useState([]);
   const [openForm, setOpenForm] = useState(false);
   const [formData, setFormData] = useState({});
   const [updateList, setUpdateList] = useState(Date.now());
   const [notify, setNotify] = useState({
     isOpen: false,
     message: "",
     type: "",
     pagename: "",
     status: "",
   });
   const CallCenterConfigurationsMenu = getCallCenterConfigurationsMenu();
   const Attributes = {
    formSize: "md",
    columns: 3,
    enableAddButton: true,
    enableAdvanceSearch: true,
    enableGroupHeading: false,
    verticalTabs: false,
    tabSize: 4,
    modes: CallCenterConfigurationsMenu.map((item) => {
      return {
        id: item.key,
        name: item.name,
        iconName: item.icon,
        url: item.url,
        description: item.description,
      };
    }),
    settingsMode: false,
  };
   useEffect(() => {
     Attributes && onLoad(Attributes);
     registerCallBacks &&
       registerCallBacks({
         openAdvancedFilter: onOpenFilter,
         openForm: onOpenForm,
       });
   }, [activePage]);
 
   function onOpenFilter() {
     setOpenFilter(true);
   }
 
   function onOpenForm() {
     setFormData({
       eventTime: Date.now(),
     });
     setOpenForm(true);
   }
 
   function onCloseFilter() {
     setOpenFilter(false);
   }
 
   function onApplyFilter(advancedFilters) {
     setAdvancedFilters(advancedFilters);
     setOpenFilter(false);
   }
 
   const deleteRow = (row) => {
     setSelectedRow(row);
     setConfirmDelete(true);
   };
 
   const editRow = (row) => {
     setFormData(row);
     setOpenForm(true);
   };
 
   const onAgree = (row) => {
     application
       .post(operationURLS.delete, {
         intId: [row.id],
       })
       .then((response) => {
         setUpdateList(Date.now());
         setNotify({
           isOpen: true,
           status: response.data.message + "" + response.data.messageDetail,
           type: "success",
           pagename: pageName,
         });
       });
 
     setConfirmDelete(false);
   };
 
   const onCancel = () => {
     setSelectedRow([]);
     setConfirmDelete(false);
   };
 
   function onSaveForm(data) { 
     if (data.id) {
       application
         .post(operationURLS.update, data)
         .then((response) => {
           setUpdateList(Date.now());
           setNotify({
             isOpen: true,
             status: response.data.message,
             type: "success",
             pagename: pageName,
           });
         })
         .catch((error) => {
           setNotify({
             isOpen: true,
             status:
               error.response.data.message,
             type: "error",
             pagename: pageName,
           });
         });
     } else {
       application
         .post(operationURLS.register, data)
         .then((response) => {
           setUpdateList(Date.now());
           setNotify({
             isOpen: true,
             status: response.data.message,
             type: "success",
             pagename: pageName,
           });
         })
         .catch((error) => {
           setNotify({
             isOpen: true,
             status:error.response.data.message,
             type: "error",
             pagename: pageName,
           });
         });
     }
     setOpenForm(false);
   }
 
   function onCloseForm() {
     setOpenForm(false);
   }
 
   return (
     <MDBox>
       <DeleteConfirmation
         entityName={pageName}
         data={selectedRow}
         columns={getColumns(deleteRow, editRow)}
         confirmDelete={confirmDelete}
         onAgree={onAgree}
         onCancel={onCancel}
       />
       <CTLBaseDialogForm
         entityName={pageName}
         columns={getColumns(deleteRow, editRow)}
         openForm={openForm}
         onSaveForm={onSaveForm}
         onCloseForm={onCloseForm}
         formData={formData}
         pageAttributes={Attributes}
       />
       <CTLTable
         apiURL={operationURLS.list}
         advancedFilters={advancedFilters}
         columns={getColumns(deleteRow, editRow)}
         entriesPerPage={false}
         canSearch
         defaultSortDirection="desc"
         defaultSortColumn="id"
         pageId={pageId}
         searchText={searchText}
         hasRowSelection={false}
         updateList={updateList}
       />
       <CTLAdvancedFilter
         entityName={pageName}
         columns={getColumns(deleteRow, editRow)}
         applyFilter={openFilter}
         onApplyFilter={onApplyFilter}
         onCloseFilter={onCloseFilter}
         advancedFilters={advancedFilters}
       />
       <CTLNotification notify={notify} setNotify={setNotify} />
     </MDBox>
   );
 }
 
 export default PredefinedMessage;
 